<template>
  <v-flex
    v-if="!loading"
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    </v-container>
    <v-data-table
      v-model="bookSelected"
      :single-select="false"
      :headers="headers"
      :items="items"
      show-select
      item-key="id"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading_book"
      class="elevation-1"
    >
      <template v-slot:item.qty="{ item }">
            {{ getQuantity(item.warehouses) }}
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
        <Paginator
          :total-items="totalItems"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.itemsPerPage"
          @change="fetchBooks"
        />
    </div>
  </div>
  </v-flex>
  <Loader v-else/>
</template>
<script>

  import { mapActions } from 'vuex';

  import { booksService } from '../../../utils/services/books.service';
  import Search from '../../shared/Inputs/Search';
  import Loader from '../../shared/Loader';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'BookSelection',
    components: { Search, Loader, Paginator },
    props: {
      perPage: {
        type: Number,
        default: 5,
      },
      propagandistId: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        loading: false,
        loading_book: false,
        items: [],
        bookSelected: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: this.perPage,
          sortDesc: [false],
          sortBy: ['books.title'],
        },
        headers: [
          { text: '', value: '' },
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.author'), value: 'author' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume', sortable: true },
          { text: this.$t('fields.year'), value: 'pubblication_year', sortable: true },
          { text: this.$t('fields.editor'), value: 'editor', sortable: true },
          { text: this.$t('fields.stock'), value: 'qty', sortable: false },
        ],
        filters: {
          search: null,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }

        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      getQuantity(warehouses) {
        let str = '';
        warehouses.forEach(warehouse => {
          str += `${warehouse.name}: ${warehouse.pivot.qty}`;
        });
        return (str) || 0;
      },
      async fetchBooks(forcePage) {
        this.loading_book = true;
        const { page, itemsPerPage } = this.pagination;
        return booksService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading_book = false;
          });
      },
    },
    async created() {
      await this.fetchBooks(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchBooks(1);
        },
      },
      bookSelected: {
        immediate: true,
        handler(val) {
          this.$emit('input', val);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchBooks(1);
          }
        },
      },

    },
  };

</script>
